'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTick = function TiTick(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 10.4c-1.6-0.9-3.7-0.3-4.5 1.3l-6.2 11.2-3.6-3.6c-1.3-1.3-3.4-1.3-4.7 0s-1.3 3.4 0 4.7l6.7 6.7c0.6 0.6 1.5 1 2.3 1 0.2 0 0.3 0 0.5-0.1 1-0.1 1.9-0.7 2.5-1.6l8.3-15c0.9-1.7 0.3-3.7-1.3-4.6z' })
        )
    );
};

exports.default = TiTick;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/tick.js
// module id = 4005
// module chunks = 0